import { useEffect } from 'react';

import * as Logging from '#/features/logging/logging';
import { isEmbedded } from '#/features/system/utils';
import { useWalletState } from '#/features/wallet/wallet-context';
import { useParentUserMetadata } from '#/features/integrations/paradex-embedded';
import { logException } from '#/features/logging/logging';

/**
 * Identifies users in logging services
 */
export default function IdentifyUser() {
  const [walletState] = useWalletState();
  const { ethereumAddress, starknetAddress } = walletState;
  const parentUserMetadata = useParentUserMetadata();

  useEffect(() => {
    if (starknetAddress == null) {
      Logging.clearUser();
      return;
    }

    if (isEmbedded() && parentUserMetadata == null) {
      logException(
        new Error(
          'Paradex runs in an iframe but no user metadata was provided.',
        ),
      );
    }

    Logging.setUser({
      id: starknetAddress,
      starknetAddress,
      ethereumAddress,
      isEmbedded: isEmbedded(),
      parentUser: parentUserMetadata,
    });
  }, [ethereumAddress, starknetAddress, parentUserMetadata]);

  return null;
}
